var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 60,
    viewBox: "0 0 65 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3751 37.5C52.4253 37.5 53.2501 36.6749 53.2501 35.625V33.2625L43.8751 13.125L27.684 17.1728C28.4364 16.0043 28.8751 14.6154 28.8751 13.125C28.8751 8.98863 25.5096 5.625 21.3751 5.625C17.2406 5.625 13.8751 8.98863 13.8751 13.125C13.8751 15.931 15.4249 18.3799 17.7119 19.6659L13.8751 20.625L0.875 45.0375C1.62513 47.2124 3.6875 48.75 6.12513 48.75H40.1251C41.1753 48.75 42.0001 47.9249 42.0001 46.875C42.0001 41.7 46.2001 37.5 51.3751 37.5V37.5ZM57.7619 44.2365L54.1474 40.6366C53.464 39.7841 52.3674 39.386 51.3751 39.386C50.2146 39.386 49.1384 39.9552 48.7384 40.4865L45.025 44.2018C43.461 45.6796 43.5468 48.1557 44.9554 49.4789C45.6439 50.2075 46.618 50.625 47.6251 50.625C47.6251 52.727 49.2731 54.375 51.3751 54.375C53.4771 54.375 55.1251 52.727 55.1251 50.625C56.1689 50.625 57.1576 50.1929 57.7253 49.5484C59.2656 48.0926 59.2365 45.6296 57.7619 44.2365V44.2365Z",
    fill: "url(#paint0_linear_900_2321)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5894 18.7033L53.25 33.2625V5.625C53.25 2.51837 50.7316 0 47.625 0H6.125C3.01837 0 0.5 2.51837 0.5 5.625V43.125C0.5 43.8 0.612625 44.4374 0.874875 45.0375L16.1611 26.2081C16.9114 25.2686 18.3394 25.268 19.0904 26.2069L24.4109 32.8574C25.1615 33.7956 26.5885 33.7956 27.3391 32.8574L38.6616 18.7041C39.412 17.7661 40.8385 17.7658 41.5894 18.7033V18.7033ZM21.375 18.75C18.2624 18.75 15.75 16.2374 15.75 13.125C15.75 10.0124 18.2624 7.5 21.375 7.5C24.4876 7.5 27 10.0124 27 13.125C27 16.2374 24.4876 18.75 21.375 18.75ZM51.375 33.75C44.1375 33.75 38.25 39.6375 38.25 46.875C38.25 54.1125 44.1375 60 51.375 60C58.6125 60 64.5 54.1125 64.5 46.875C64.5 39.6375 58.6125 33.75 51.375 33.75ZM56.4374 48.1874C55.7629 48.9374 54.4874 48.9376 53.8125 48.1874L53.2499 47.6624V50.625C53.2499 51.6749 52.425 52.5 51.3749 52.5C50.3247 52.5 49.4999 51.6749 49.4999 50.625V47.6624L48.9372 48.1874C48.2247 48.9374 47.025 48.9374 46.3124 48.1874C45.5624 47.4749 45.5624 46.2749 46.3124 45.5624L50.0624 41.8124C50.6204 41.1146 52.0787 41.0515 52.6872 41.8124L56.4372 45.5624C57.1875 46.2749 57.1875 47.4749 56.4374 48.1874Z",
    fill: "url(#paint1_linear_900_2321)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_900_2321",
    x1: 29.8746,
    y1: 54.375,
    x2: 29.8746,
    y2: 5.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_900_2321",
    x1: 32.5,
    y1: 60,
    x2: 32.5,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3AC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA7FB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.5f8a79d5.svg";
export { ForwardRef as ReactComponent };